document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('.foto-box');
  if (!box) return; // если на странице нет контейнера — ничего не делаем

  box.addEventListener('click', (e) => {
    const card = e.target.closest('.foto-card');
    if (!card) return;

    const img = card.querySelector('img');
    if (!img) return;

    const src = img.getAttribute('src');
    if (!src) return;

    // создаём оверлей
    const overlay = document.createElement('div');
    overlay.className = 'foto-modal-overlay';
    overlay.innerHTML = `
      <div class="foto-modal-content">
        <span class="foto-modal-close" role="button"><svg><use xlink:href="#x" /></svg></span>
        <img src="${src}" alt="">
      </div>
    `;

    // функция закрытия (удаляет overlay и отписывает keydown)
    function closeOverlay() {
      if (!overlay.parentNode) return;
      document.removeEventListener('keydown', onKeyDown);
      overlay.remove();
    }

    // клик по фону или по кресту
    overlay.addEventListener('click', (ev) => {
      // если кликнули по фоновой обёртке (overlay) или по кресту — закрываем
      if (ev.target.classList.contains('foto-modal-overlay') ||
          ev.target.classList.contains('foto-modal-close')) {
        closeOverlay();
      }
    });

    // закроет по Esc, и удалит себя при закрытии
    function onKeyDown(ev) {
      if (ev.key === 'Escape' || ev.key === 'Esc') {
        closeOverlay();
      }
    }
    document.addEventListener('keydown', onKeyDown);

    document.body.appendChild(overlay);
  });
});
